import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { getEventById } from "../../../services/EventService";
import applicationDetailModel from "../../../components/Model/ApplicationDetailModel";
import eventApplicationCreateModel from "../../../components/Model/EventApplicationModel";
import { useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../../../redux/Models/Application/constants";
import {
  ApplicationStatus,
  ApplicationType,
  EventActionType,
  EventStatus,
} from "../../../constants/Enum";
import RolePermission from "../../../services/RolePermission";
import { Modal, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";

import {
  AuthService,
  TraderUnitService,
  EventApplicationService,
  EventService,
  BusinessProfileService,
} from "../../../services";
import {
  formatDateENGB,
  addDefaultImg,
  formatAmount,
  handleConsoleError,
} from "../../../utils/common-methods";
import { injectModels } from "../../../redux/injectModels";
import { toast } from "react-toastify";
const ApplicationLanding = (props) => {
  const [eventData, setEventData] = useState({ ...applicationDetailModel });
  const [applicationForValue, setApplicationForValue] = useState("R");
  const [isAuction, setAuction] = useState(false);
  const [isShowLiveBids, setShowLiveBids] = useState(false);
  const [isClose, setClose] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [eventApplicationData, setEventApplicationData] = useState({
    ...eventApplicationCreateModel,
  });
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [IsPublishedEvent, setPublishedEvent] = useState(false);
  //const [isEOActive, setEOActive] = useState(true);

  const [unitList, setUnitList] = useState([]);
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type, eventId } = useParams();
  const loginUser = AuthService.getLoginUser();
  const [isExpanded, setIsExpanded] = useState(false);
  const [showFullTerms, setShowFullTerms] = useState(false);
  const [showFullApplication, setShowFullApplication] = useState(false);
  const [appType, setApplicationType] = useState(0);

  const toggleDescription = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const shouldTruncate = eventData?.eventDescription?.length > 50;

  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  const IsClosed = (deadLine, isPublishedEvent) => {
    const deadlineDate = new Date(deadLine);

    // Normalize both dates to compare only the date (ignore time)
    const deadlineDateOnly = new Date(
      deadlineDate.getFullYear(),
      deadlineDate.getMonth(),
      deadlineDate.getDate(),
    );
    const todayDateOnly = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
    );
    return deadlineDateOnly >= todayDateOnly ? false : true;
  };

  const termsConditionText = eventApplicationData?.termsCondition || "";
  const displayTerms =
    termsConditionText?.length > 800 && !showFullTerms
      ? `${termsConditionText.substring(
          0,
          800,
        )} <a href="#!" class="toggle-text">show more...</a>`
      : termsConditionText?.length < 800
      ? termsConditionText
      : `${termsConditionText} <a href="#!" class="toggle-text">show less</a>`;

  const applicationDescription = eventApplicationData?.description || "";
  const displayApplicationDescription =
    applicationDescription.length > 800 && !showFullApplication
      ? `${applicationDescription.substring(
          0,
          800,
        )} <a href="#!" class="toggle-text">show more...</a>`
      : applicationDescription.length < 800
      ? applicationDescription
      : `${applicationDescription} <a href="#!" class="toggle-text">show less</a>`;

  const handleView = async (eventAppId) => {
    try {
      if (type === "R") {
        navigate(
          routes.SUBMISSION_RETAILER_DETAILS_TRADER.replace(
            ":eventId",
            eventId,
          ).replace(":appId", eventAppId),
        );
      } else {
        navigate(
          routes.SUBMISSION_CATERER_DETAILS_TRADER.replace(
            ":eventId",
            eventId,
          ).replace(":appId", eventAppId),
        );
      }
    } catch (error) {}
  };

  const getPriceLable = () => {
    if (appType === ApplicationType.Tender) {
      return "Suggested Price";
    }
    if (appType === ApplicationType.Turnover) {
      return "Commitment Fee";
    }
    if (appType === ApplicationType.Bid) {
      return "Minimum Starting Price";
    }
    return "Price";
  };

  const getButtonLable = (selectedItem) => {
    const isApply =
      selectedItem?.traderPitchId === selectedUnit ||
      selectedItem?.traderUnitId === selectedUnit;
    const isStatus =
      selectedItem?.status === ApplicationStatus.Approved ||
      selectedItem?.status === ApplicationStatus.Awaiting ||
      selectedItem?.status === ApplicationStatus.Completed;
    if (isApply && isStatus) {
      return "View";
    }

    if (isApply && appType === ApplicationType.Tender) {
      return "Resume to Tender";
    }
    if (isApply && appType === ApplicationType.Turnover) {
      return "Resume to Turnover Based Rent";
    }
    if (isApply && appType === ApplicationType.Bid) {
      return "Resume to Bid";
    }
    if (isApply && appType === ApplicationType.Fixed) {
      return "Resume";
    }

    if (!isApply && appType === ApplicationType.Tender) {
      return "Apply to Tender";
    }
    if (!isApply && appType === ApplicationType.Turnover) {
      return "Apply to Turnover Based Rent";
    }
    if (!isApply && appType === ApplicationType.Bid) {
      return "Apply to Bid";
    }
    if (!isApply && appType === ApplicationType.Fixed) {
      return "Apply";
    }
    return "Apply";
  };

  const onClose = () => {
    setValue("unitId", "");
    setSelectedUnit("");
    setShowModal(false);
  };

  const selectUnitFirst = (url) => {
    localStorage.setItem("appURL", url);
    setShowModal(true);
  };

  const handleApplyPictchClick = (item) => {
    setSelectedItem(item);
    let url = routes.RETAIL_APPLICATION_FORM.replace(
      ":eventId",
      eventId,
    ).replace(":pitchId", item?.id);
    if (type === "C") {
      url = routes.CATER_APPLICATION_FORM.replace(":eventId", eventId).replace(
        ":unitId",
        item.id,
      );
    }
    if (loginUser === null) {
      localStorage.setItem("returnUrl", url);
      dispatch({
        type: CONSTANTS.SET_CURRENT_MODAL,
        payload: CONSTANTS.LOGIN_MODAL,
      });
    } else {
      selectUnitFirst(url);
    }
  };
  const onSubmit = () => {
    const url = localStorage.getItem("appURL");
    if (!selectedUnit || selectedUnit.trim().length === 0) {
      Swal.fire({
        title: "Apply Application",
        text: "Please add menus and documents to your unit before applying.",
        confirmButtonText: "OK",
        icon: "warning",
        buttonsStyling: false,
      });
    }

    if (selectedUnit && url) {
      const unitSeleted = unitList.find((x) => x.id === selectedUnit);
      TraderUnitService.setSelectedTraderUnit({
        id: unitSeleted?.id,
        name: unitSeleted?.name,
      });
      if (
        selectedItem &&
        (selectedItem?.status === ApplicationStatus.Awaiting ||
          selectedItem?.status === ApplicationStatus.Approved ||
          selectedItem?.status === ApplicationStatus.Completed)
      ) {
        if (
          selectedItem?.traderPitchId === unitSeleted?.id ||
          selectedItem?.traderUnitId === unitSeleted?.id
        ) {
          handleView(selectedItem?.eventApplicationId);
        } else {
          localStorage.removeItem("appURL");
          navigate(url);
        }
      } else {
        localStorage.removeItem("appURL");
        navigate(url);
      }
    }
  };

  const handleUnitChange = async (e) => {
    props.application.setLoading(true);
    const selectedId = e.target.value;

    const unitSeleted = unitList.find((x) => x.id === selectedId);
    if (
      unitSeleted &&
      unitSeleted?.isDocumentAvailable &&
      unitSeleted?.isMenuAvailable
    ) {
      if (selectedId && selectedId.trim().length > 5) {
        setSelectedUnit(selectedId);
        const response = await EventService.getEventApplicationStatusByPitchId(
          type,
          eventApplicationData?.id,
          selectedItem.id,
          selectedId,
        );
        if (response?.isSuccess && response?.data.length > 0) {
          const updatedItem = { selectedItem, ...response?.data?.[0] };
          setSelectedItem(updatedItem);
          getButtonLable(updatedItem);
        }
        //setValue("unitId", selectedId);
        clearErrors("unitId");
      }
      props.application.setLoading(false);
    } else {
      props.application.setLoading(false);
      Swal.fire({
        title: "Apply Application",
        text: "Please add menus and documents to your unit before applying.",
        confirmButtonText: "OK",
        icon: "warning",
        buttonsStyling: false,
      });
      setSelectedUnit("");
      setValue("unitId", "");
      clearErrors("unitId");
    }
  };

  useEffect(() => {
    const fetchEventOrganizer = async (userId) => {
      if (!userId) return;
      try {
        const res = await BusinessProfileService.getBusinessProfileById(userId);
        if (res?.isSuccess && res?.data) {
          setEventData((prev) => ({
            ...prev,
            organizerName: res?.data.businessName,
            organizerLogo: res?.data.businessLogoUrl,
            userId: res?.data.userId,
          }));
          if (res?.data?.isActive === false) {
            setPublishedEvent(res?.data?.isActive);
          }
        }
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    };
    const getTraderUnitData = async () => {
      try {
        if (loginUser) {
          const res = await TraderUnitService.getTraderUnitListByTraderId(
            loginUser?.id,
          );
          if (res?.isSuccess && res?.data?.length > 0) {
            setUnitList(
              res?.data
                .filter((x) => x.isActive === true)
                .map((unit) => ({
                  id: unit.id,
                  name: unit.unitName,
                  isMenuAvailable: unit.isMenuAvailable,
                  isDocumentAvailable: unit.isDocumentAvailable,
                })),
            );
          }
        }
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    };
    const getApplicationData = async () => {
      try {
        const eventApplication = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          type,
        );
        if (eventApplication?.isSuccess) {
          setApplicationType(eventApplication?.data?.[0]?.applicationType);
          const applicationMappedData = {
            ...eventApplicationCreateModel,
            ...eventApplication?.data?.[0],
          };

          if (
            eventApplication?.data?.[0]?.applicationType ===
              ApplicationType.Tender ||
            eventApplication?.data?.[0]?.applicationType === ApplicationType.Bid
          ) {
            if (
              eventApplication?.data?.[0]?.applicationType ===
              ApplicationType.Bid
            ) {
              setShowLiveBids(true);
            }
            const bidDate = new Date(
              eventApplication?.data?.[0]?.auctionStartDate,
            );
            const bidEndDate = addDays(
              bidDate,
              eventApplication?.data?.[0]?.auctionsDays,
            );
            const today = new Date();

            if (today < bidDate || today > bidEndDate) {
              setAuction(true);
            } else {
              setAuction(false);
            }
          } else {
            setAuction(false);
          }
          setEventApplicationData(applicationMappedData);
          var application = await EventApplicationService.getTraderApplicationStatus(
            eventApplication.data?.[0]?.id,
            loginUser?.id,
            type,
          );

          if (application.isSuccess) {
            // setEventApplicationId(application?.data?.id);
            // application?.data?.status === 1
            //   ? setApplicationStatus(true)
            //   : setApplicationStatus(false);
            // if (application?.data?.status >= 1) {
            //   setIsApplied(true);
            // }
          }
        }
        setClose(IsClosed(eventApplication?.data?.[0]?.deadLine));
      } catch (error) {
        handleConsoleError(error);
        // toast.error(error?.message|| message);
      }
    };
    const getEventData = async () => {
      try {
        if (eventId.length === 36) {
          const response = await getEventById(eventId);
          if (response?.isSuccess) {
            const event = response?.data;
            setEventData(event);

            setPublishedEvent(
              event.eventStatusId === EventStatus.Published ||
                event.eventStatusId === EventStatus.InProgress,
            );
            await Promise.all([
              fetchEventOrganizer(event?.userId),
              getTraderUnitData(),
              getApplicationData(),
            ]);
          }
        } else {
          navigate(routes.ERROR);
        }
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    };
    getEventData();
    setApplicationForValue(type);
  }, []);

  const fetchBids = async () => {
    try {
      if (isShowLiveBids) {
        const response = await getEventById(eventId);
        if (response?.isSuccess) {
          setEventData(response?.data);
        }
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  useEffect(() => {
    // Fetch the initial bids when the component mounts

    // Set an interval to fetch the bids every 30 seconds
    const intervalId = setInterval(fetchBids, 30000); // 30 seconds = 30000 ms

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [isShowLiveBids]);

  return (
    <React.Fragment>
      <div className="layout-wrapper landing">
        <section className="event-home-hd">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-12">
                <div className="event-home-hd1 ev-img">
                  {eventApplicationData?.image === null ||
                  eventApplicationData?.image === "" ? (
                    <img src={addDefaultImg} alt="" onError={addDefaultImg} />
                  ) : (
                    <img
                      src={eventApplicationData?.image}
                      alt=""
                      onError={addDefaultImg}
                    />
                  )}
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="event-home-hd1 deadline-event">
                  <h3>{eventApplicationData?.title} </h3>
                  <p>
                    <img src="/assets/images/clock1.png" alt="" />{" "}
                    <span className="large-p2z">
                      <span className="large-p">Deadline: </span>{" "}
                      {formatDateENGB(eventApplicationData?.deadLine)}
                    </span>
                  </p>
                  <Link to={routes.EVENT_PAGE + "/" + eventData?.url}>
                    <p>
                      <img src="/assets/images/fix-date.png" alt="" />{" "}
                      <span className="large-p">{eventData?.eventName}</span>
                    </p>
                  </Link>
                  <p>
                    <img src="/assets/images/date-event.png" alt="" />{" "}
                    <span className="large-p2z">
                      <span className="large-p">Date:</span>{" "}
                      {eventData?.startDateStr} {eventData?.startTimeStr} -{" "}
                      {eventData?.endDateStr} {eventData?.endTimeStr}
                    </span>
                  </p>
                  <p>
                    <img src="/assets/images/placeholder.png" alt="" />{" "}
                    {(() => {
                      const fullAddress = `${
                        eventData?.street1 ? ` ${eventData?.street1},` : ""
                      }${eventData?.street2 ? ` ${eventData?.street2},` : ""}${
                        eventData?.city ? ` ${eventData?.city},` : ""
                      }${
                        eventData?.stateName ? ` ${eventData?.stateName},` : ""
                      }${eventData?.zip ? ` ${eventData?.zip},` : ""}${
                        eventData?.countryName
                          ? ` ${eventData?.countryName}`
                          : ""
                      }`;
                      return fullAddress?.length > 500
                        ? `${fullAddress.slice(0, 500)}...`
                        : fullAddress;
                    })()}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="event-home-hd1">
                  <div className="london-uro"></div>

                  {(!loginUser ||
                    (loginUser &&
                      RolePermission.isAccess(
                        loginUser?.role,
                        EventActionType.ApplyApplication,
                      ))) && (
                    <div className="apply-bt">
                      {(isClose || !IsPublishedEvent) && (
                        <p>
                          {" "}
                          <span className="large-p2z">
                            <span className="large-p">Status: </span> Closed
                          </span>
                        </p>
                      )}
                      {isAuction && IsPublishedEvent && !isClose && (
                        <React.Fragment>
                          <p>
                            {" "}
                            <span className="large-p2z">
                              <span className="large-p">Start Date: </span>{" "}
                              {formatDateENGB(
                                eventApplicationData?.auctionStartDate,
                              )}
                            </span>
                          </p>
                          <p>
                            <span className="large-p2z">
                              <span className="large-p">End Date: </span>{" "}
                              {formatDateENGB(
                                addDays(
                                  new Date(
                                    eventApplicationData?.auctionStartDate,
                                  ),
                                  eventApplicationData?.auctionsDays,
                                ),
                              )}
                            </span>
                          </p>
                        </React.Fragment>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-the-application">
          <div className="container">
            <h3>About the Application</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: displayApplicationDescription,
              }}
              onClick={(e) => {
                if (e.target.className === "toggle-text") {
                  e.preventDefault();
                  setShowFullApplication((prev) => !prev);
                }
              }}
            />
          </div>
        </section>
        <section className="about-the-application terms">
          <div className="container">
            <h3>About the Event</h3>
            {eventData?.coverPicSquareUrl && (
              <div className="row justify-content-center">
                <div className="col-12 about-the-event2">
                  <img
                    src={eventData?.coverPicSquareUrl}
                    alt="Event"
                    onError={addDefaultImg}
                  />
                </div>
              </div>
            )}
            <p>
              {isExpanded || !shouldTruncate ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: eventData?.eventDescription,
                  }}
                />
              ) : (
                <p
                  dangerouslySetInnerHTML={{
                    __html: eventData?.eventDescription?.slice(0, 600),
                  }}
                />
              )}
              {shouldTruncate && (
                <a
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDescription();
                  }}
                >
                  {isExpanded
                    ? " show less"
                    : eventData?.eventDescription?.length < 600
                    ? ""
                    : " show more..."}
                </a>
              )}
            </p>
          </div>
        </section>
        <section className="about-the-application terms">
          <div className="container">
            <h3>Terms & Conditions</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: displayTerms,
              }}
              onClick={(e) => {
                if (e.target.className === "toggle-text") {
                  e.preventDefault();
                  setShowFullTerms((prev) => !prev);
                }
              }}
            />
          </div>
        </section>
        {applicationForValue === "R" && (
          <section className="pitch-details">
            <div className="container">
              <h3>Pitch Details</h3>
              <p>
                <b>Note:</b> Buyers, card processing and admin fee may apply to
                this transaction
              </p>
              <div style={{ width: "100%", overflow: "auto" }}>
                <table className="table table-bordered">
                  <thead>
                    <tr style={{ backgroundColor: "#5b5b5b" }}>
                      <th
                        style={{
                          width: "25%",
                          padding: "8px 12px",
                          color: "#fff",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Pitch Type
                      </th>
                      <th
                        style={{
                          width: "12%",
                          padding: "8px 12px",
                          color: "#fff",
                        }}
                      >
                        {getPriceLable()}
                      </th>
                      {isShowLiveBids && (
                        <th
                          style={{
                            width: "12%",
                            padding: "8px 12px",
                            color: "#fff",
                          }}
                        >
                          Live Bid
                        </th>
                      )}
                      <th style={{ padding: "8px 12px", color: "#fff" }}>
                        Description
                      </th>{" "}
                      <th style={{ padding: "8px 12px", color: "#fff" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventData?.eventPitches?.map((item, idx) => {
                      if (item.isActive) {
                        return (
                          <tr key={item + idx}>
                            <td>
                              {item?.pitchTitle} ({item?.pitchLength}' x{" "}
                              {item?.pitchWidth}' Space)
                              <div style={{ marginTop: "10px" }}>
                                {!isAuction &&
                                  !isClose &&
                                  item?.statusLabel &&
                                  !item?.statusLabel
                                    ?.toLowerCase()
                                    ?.includes("sold") && (
                                    <span
                                      class="alert alert-pitch-danger"
                                      style={{
                                        marginTop: "10px",
                                        padding: "5px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {" "}
                                      {item?.statusLabel}{" "}
                                    </span>
                                  )}
                              </div>
                            </td>
                            <td>
                              {!item?.statusLabel
                                ?.toLowerCase()
                                ?.includes("sold") &&
                                `£${formatAmount(item?.amount)}`}
                              <br />
                            </td>
                            {/* <td>
                              £{formatAmount(item?.amount)} <br />
                            </td> */}
                            {isShowLiveBids &&                       
                                  !item?.statusLabel
                                    ?.toLowerCase()
                                    ?.includes("sold") && (
                              <td>£{formatAmount(item?.currentBidAmount)}</td>
                            )}
                             {isShowLiveBids &&  item?.statusLabel &&                        
                                  item?.statusLabel
                                    ?.toLowerCase()
                                    ?.includes("sold") && (
                              <td></td>
                            )}
                            <td
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            ></td>
                            <td>
                              {!isAuction &&
                                !isClose &&                              
                                !item?.statusLabel
                                  ?.toLowerCase()
                                  ?.includes("sold") && (
                                  <button
                                    className="apply-small"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleApplyPictchClick(item);
                                    }}
                                  >
                                    {getButtonLable()}{" "}
                                  </button>
                                )}
                              {!isAuction &&
                                !isClose &&
                                item?.statusLabel
                                  ?.toLowerCase()
                                  ?.includes("sold") && (
                                  <button
                                    className="apply-small button-gray"
                                    disabled
                                    onClick={(e) => {
                                      e.preventDefault();
                                    }}
                                  >
                                    Sold Out
                                  </button>
                                )}
                            </td>
                          </tr>
                        );
                      } else {
                        return <></>;
                      }
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}
        {applicationForValue === "C" && (
          <section className="pitch-details">
            <div className="container">
              <h3>Caterers Details</h3>
              <p>
                <b>Note:</b> Buyers, card processing and admin fees may apply to
                this transaction
              </p>
              <div style={{ width: "100%", overflow: "auto" }}>
                <table className="table table-bordered">
                  <thead>
                    <tr style={{ backgroundColor: "#5b5b5b" }}>
                      <th
                        style={{
                          width: "25%",
                          padding: "8px 12px",
                          color: "#fff",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Pitch Type
                      </th>
                      <th
                        style={{
                          width: "12%",
                          padding: "8px 12px",
                          color: "#fff",
                        }}
                      >
                        {getPriceLable()}
                      </th>
                      {isShowLiveBids && (
                        <th
                          style={{
                            width: "12%",
                            padding: "8px 12px",
                            color: "#fff",
                          }}
                        >
                          Live Bids
                        </th>
                      )}
                      <th style={{ padding: "8px 12px", color: "#fff" }}>
                        Description
                      </th>
                      <th style={{ padding: "8px 12px", color: "#fff" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventData?.eventUnits?.map((item, idx) => {
                      if (item.isActive) {
                        return (
                          <tr key={item + idx}>
                            <td>
                              {item?.unitTitle}
                              <div style={{ marginTop: "10px" }}>
                                {!isAuction &&
                                  !isClose &&
                                  item?.statusLabel &&                        
                                  !item?.statusLabel
                                    ?.toLowerCase()
                                    ?.includes("sold") && (
                                    <span
                                      class="alert alert-pitch-danger"
                                      style={{
                                        marginTop: "10px",
                                        padding: "5px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {" "}
                                      {item?.statusLabel}{" "}
                                    </span>
                                  )}
                              </div>
                            </td>
                            <td>
                              {!item?.statusLabel
                                ?.toLowerCase()
                                ?.includes("sold") &&
                                `£${formatAmount(item?.amount)}`}
                              <br />
                            </td>
                            {/* <td>£{formatAmount(item?.amount)}</td> */}
                            {isShowLiveBids &&                     
                                  !item?.statusLabel
                                    ?.toLowerCase()
                                    ?.includes("sold") && (
                              <td>£{formatAmount(item?.currentBidAmount)}</td>
                            )}
                             {isShowLiveBids &&  item?.statusLabel &&                        
                                  item?.statusLabel
                                    ?.toLowerCase()
                                    ?.includes("sold") && (
                              <td></td>
                            )}
                            <td
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            ></td>
                            <td>
                              {" "}
                              {!isAuction &&
                                !isClose &&
                                 !item?.statusLabel
                                  ?.toLowerCase()
                                  ?.includes("sold") && (
                                  <button
                                    className="apply-small"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleApplyPictchClick(item);
                                    }}
                                  >
                                    {getButtonLable()}{" "}
                                  </button>
                                )}
                              {!isAuction &&
                                !isClose &&
                                 item?.statusLabel
                                  ?.toLowerCase()
                                  ?.includes("sold") && (
                                  <button
                                    className="apply-small button-gray"
                                    disabled
                                    onClick={(e) => {
                                      e.preventDefault();
                                    }}
                                  >
                                    Sold Out
                                  </button>
                                )}
                            </td>
                          </tr>
                        );
                      } else {
                        return <></>;
                      }
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        <section className="pitch-details questions1">
          <div className="container">
            <h3>Questions on the application</h3>
            <div className="row questions2">
              <div className="col-lg-12 col-md-12 col-sm-12 questions4">
                <div className="questions3 first">
                  <h5>User information</h5>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Business name</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Legal business name</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Contact name</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Address</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Email</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Phone</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Website (optional)</li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 br1">
                      <ul>
                        <li>Logo (optional)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="questions3">
                  <h5>Additional information</h5>
                  {type === "R" && (
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li>
                            Have you exhibited with one of our shows before?
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li>How many pitches do you plan on purchasing?</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li> Power requirements and payment?</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li>
                            What name should we use for you in our exhibitor
                            directory for attendees to find you?
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>What kind of items do you sell?</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>
                            {" "}
                            Please type yes to confirm that you understand that
                            you cannot sell weapons,
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>
                            {" "}
                            Swords, tobacco, vape, food, drink, animals,
                            timeshares, or bootlegs, and also to indicate that
                            you will adhere to all items in the agreement listed
                            below and at checkout.
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>
                            If you have requests about placement, please enter
                            that here. If not, type no.
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {type === "C" && (
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li>Have you applied to one of our events before?</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li>
                            How many units do you plans and measurements of your
                            unit?
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li> Power requirements and payment?</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 br1">
                        <ul>
                          <li>
                            Most recent national food hygiene rating scheme
                            score (minimum 4) relevant to the named unit.
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>
                            Food hygiene training: please provide evidence that
                            the owner/manager/supervisor has Level 3 or 2
                            certification (or equivalent)
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li> HACCP documentation (food vendors only)</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>Gas safety test certificate</li>
                        </ul>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 ">
                        <ul>
                          <li>
                            {" "}
                            Please specify which local authority your unit is
                            registered with.
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal show={showModal} onHide={onClose} centered>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>
              Please select a unit to proceed with the application
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {unitList.length === 0 && (
              <p className="text-danger" style={{ fontSize: "16px" }}>
                <b>Warning! -</b> Visit your{" "}
                <Link
                  style={{ textDecoration: "underline", color: "red" }}
                  to="/trader/units"
                >
                  Shopfront
                </Link>{" "}
                to upload your units and{" "}
                <Link
                  style={{ textDecoration: "underline", color: "red" }}
                  to="/shopfront"
                >
                  Menus/products
                </Link>
              </p>
            )}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Form.Group className="col-6 mb-3">
                <Form.Label>Your Units</Form.Label>
                <Form.Select
                  {...register("unitId", {
                    required: "select unit to apply application",
                  })}
                  onChange={(e) => {
                    handleUnitChange(e);
                  }}
                  defaultValue={selectedUnit}
                  placeholder="Select"
                >
                  <option value="">Select Unit</option>
                  {unitList.map((unit) => (
                    <option key={unit.id} value={unit.id}>
                      {unit.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {errors.unitId && (
                <span className="text-danger">{errors.unitId?.message}</span>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {getButtonLable(selectedItem)}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default injectModels(["application"])(ApplicationLanding);
